import { Action, createReducer, on } from '@ngrx/store';
import * as AuthActions from '../actions/auth.actions';

export interface AuthState {
  token: string | null | undefined;
}

const TOKEN_KEY = 'token';

export const initialState: AuthState = {
  token: localStorage.getItem(TOKEN_KEY),
};

export const authReducer = createReducer<AuthState>(
  initialState,
  on(
    AuthActions.setTokenAction,
    (state: AuthState, { payload: { token } }: { payload: { token: string | null | undefined } }) => {
      if (token) {
        localStorage.setItem(TOKEN_KEY, token);
      } else {
        localStorage.removeItem(TOKEN_KEY);
      }

      return {
        ...state,
        token,
      };
    }
  )
);

export function AuthReducer(state: AuthState | undefined, action: Action): AuthState {
  return authReducer(state, action);
}

export const getToken = (state: AuthState) => state.token;
